"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _core = require("@material-ui/core/");
var _clsx = _interopRequireDefault(require("clsx"));
var _dates = require("../_utils/dates");
var _webinars = require("../_utils/webinars");
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var labelWidth = '70px';
  return {
    webinarHeading: {
      margin: '24px 0 16px',
      display: 'block'
    },
    primaryCategory: {
      marginBottom: '0 !important',
      fontSize: theme.typography.fontSize,
      fontWeight: theme.typography.fontWeightMedium
    },
    primarySubCategoryList: {
      paddingLeft: '1.3em',
      marginTop: '0',
      '& li': {
        fontSize: '14px',
        fontWeight: theme.typography.fontWeightRegular
      }
    },
    webinarInformation: {
      margin: '0',
      padding: '0',
      listStyleType: 'none'
    },
    label: {
      display: 'inline-block',
      width: labelWidth
    },
    button: {
      color: "".concat(theme.palette.common.white, " !important"),
      '&:hover': {
        textDecoration: 'none !important'
      }
    },
    sessionItem: {
      display: 'flex'
    },
    sessionLabel: {
      minWidth: labelWidth
    }
  };
});
var WebinarSidebar = function WebinarSidebar(props) {
  var classes = useStyles();
  var webinarInformationHeading = props.webinarInformationHeading,
    webinarLanguage = props.webinarLanguage,
    webinarInformationText = props.webinarInformationText,
    duration = props.duration,
    _props$webinarSession = props.webinarSessions,
    webinarSessions = _props$webinarSession === void 0 ? [] : _props$webinarSession,
    primaryCategory = props.primaryCategory,
    primarySubCategory = props.primarySubCategory,
    _props$translations = props.translations,
    translations = _props$translations === void 0 ? {
      duration: 'Duration',
      language: 'Language',
      presented: 'Presented',
      session: 'Session'
    } : _props$translations;
  var orderedSessions = (0, _webinars.sortWebinarSessions)(webinarSessions);
  var content = __jsx("div", null, webinarInformationHeading && __jsx(_core.Typography, {
    component: "strong",
    variant: "h3",
    dangerouslySetInnerHTML: {
      __html: webinarInformationHeading
    },
    className: classes.webinarHeading
  }), webinarInformationText && __jsx(_core.Typography, {
    component: "p",
    dangerouslySetInnerHTML: {
      __html: webinarInformationText
    }
  }), primaryCategory && __jsx(_core.Typography, {
    component: "p",
    className: classes.primaryCategory,
    dangerouslySetInnerHTML: {
      __html: primaryCategory
    }
  }), primarySubCategory && __jsx("ul", {
    className: classes.primarySubCategoryList
  }, __jsx(_core.Typography, {
    component: "li",
    dangerouslySetInnerHTML: {
      __html: primarySubCategory
    }
  })), __jsx("ul", {
    className: (0, _clsx.default)(classes.webinarInformation)
  }, __jsx("li", null, __jsx("p", null, __jsx("span", {
    className: (0, _clsx.default)(classes.label)
  }, __jsx("b", {
    dangerouslySetInnerHTML: {
      __html: "".concat(translations.duration, ":")
    }
  })), __jsx("span", null, duration))), webinarLanguage && __jsx("li", null, __jsx("p", null, __jsx("span", {
    className: (0, _clsx.default)(classes.label)
  }, __jsx("b", {
    dangerouslySetInnerHTML: {
      __html: "".concat(translations.language, ":")
    }
  })), __jsx("span", null, webinarLanguage))), orderedSessions === null || orderedSessions === void 0 ? void 0 : orderedSessions.map(function (session, idx) {
    var dateobj = (0, _webinars.dateFormatter)(session.sessionDateTime, session.sessionTimeZone);
    var isUpcoming = !(0, _dates.isDateOlderThanToday)(session.sessionDateTime);
    var sessionDate = isUpcoming ? "".concat(session.sessionDateTime, " ").concat(session.sessionTimeZone) : "".concat(translations.presented.toLowerCase(), " ").concat(dateobj.presentedDate);
    return __jsx("li", {
      key: "session-".concat(idx)
    }, __jsx("p", {
      className: classes.sessionItem
    }, __jsx("span", {
      className: (0, _clsx.default)(classes.label, classes.sessionLabel)
    }, __jsx("b", {
      dangerouslySetInnerHTML: {
        __html: "".concat(translations.session, " ").concat(idx + 1, ":")
      }
    })), __jsx("span", null, sessionDate)), session.buttonText.length > 0 && __jsx("p", null, __jsx(_core.Button, {
      className: (0, _clsx.default)(classes.button),
      target: session.openInNewTab ? '_blank' : '_self',
      href: session.buttonUrl,
      variant: "contained",
      color: "primary"
    }, __jsx("span", {
      dangerouslySetInnerHTML: {
        __html: session.buttonText
      }
    }))));
  })));
  return __jsx("div", null, content);
};
var WebinarSidebarEditConfig = {
  emptyLabel: 'Webinar Sidebar',
  isEmpty: function isEmpty(props) {
    if (props.webinarLanguage) {
      return false;
    } else {
      return true;
    }
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/webinarsidebar')(WebinarSidebar, WebinarSidebarEditConfig);
exports.default = _default;